import React from 'react';
import iconTemplate from './IconTemplate';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="-0.625 -0.625 24 24"
        id="Cloud-Check--Streamline-Flex"
        height="24"
        width="24"
    >
        <g id="cloud-check--cloud-network-internet-check-server-approve">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.75207875 19.1953125 10.41116375 21.9375c1.25126625 -3.5943375 2.29334625 -5.1715625 4.653415000000001 -7.3125"
                strokeWidth="1.25"
            ></path>
            <path
                id="Subtract"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M18.518825 15.32271C20.428687500000002 14.517928750000001 21.9375 13.07606625 21.9375 10.49503c0 -2.55334625 -1.4142375 -4.00673 -3.9333125 -4.05068625C17.823325 2.83300875 15.64116125 0.8125 11.887525 0.8125c-3.079765 0 -5.1016225 1.3601575 -5.828257499999999 3.8431575l-0.06436625 -0.00022749999999999997C2.6781625 4.65543 0.8125 6.5210925 0.8125 9.83783125c0 4.70942875 4.6777575 6.01107 8.200660000000001 6.36640875"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector 2591"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5.9445749999999995 4.658095c1.9136324999999998 0 3.6250662499999997 1.261325 4.16494 2.4136937499999997"
                strokeWidth="1.25"
            ></path>
        </g>
    </svg>,
) as React.FC;
